import Image from "@/app/[lang]/components/shared/SmartImage";

import style from '../style.module.scss';

interface StationPricingCardsProps {
    pricing: any[];
    stationId: string | number;
    pricingKeyPrefix: string;
    promoLabel: string;
    getConnectorIcon: (connectorType: string) => { src: string } | null;
}

const StationPricingCards = ({
    pricing,
    stationId,
    pricingKeyPrefix,
    promoLabel,
    getConnectorIcon,
}: StationPricingCardsProps) => {
    return (
        <>
            {pricing.map((pricingItem: any, index: number) => {
                const connectorIcon = getConnectorIcon(pricingItem.connectorType);

                return (
                    <div key={`${stationId}-${pricingKeyPrefix}-${index}`} className={style.stationPricingCard}>
                        <div className={style.stationPricingHeader}>
                            {connectorIcon && (
                                <Image
                                    className={style.stationPricingIcon}
                                    src={connectorIcon.src}
                                    alt={pricingItem.connectorType}
                                    width={16}
                                    height={16}
                                />
                            )}
                            <span className={style.stationPricingConnector}>
                                {pricingItem.connectorType}
                            </span>
                            {pricingItem.count > 1 && (
                                <span className={style.stationPricingCountBadge}>
                                    {pricingItem.count} puncte de încărcare
                                </span>
                            )}
                        </div>

                        <div className={style.stationPricingGrid}>
                            <div className={style.stationPricingColumn}>
                                <span className={style.stationPricingLabel}>Membru</span>
                                <strong className={style.stationPricingValue}>
                                    {pricingItem.memberPrice || '-'}
                                </strong>
                            </div>
                            <div className={style.stationPricingColumn}>
                                <span className={style.stationPricingLabel}>Vizitator</span>
                                <strong className={style.stationPricingValue}>
                                    {pricingItem.visitorPrice || '-'}
                                </strong>
                            </div>
                            <div className={style.stationPricingColumn}>
                                <span className={style.stationPricingLabel}>Abonament incepand de la</span>
                                <strong className={style.stationPricingValuePromo}>
                                    {promoLabel}
                                </strong>
                            </div>
                        </div>

                        <div className={style.stationPricingNote}>
                            * Pretul contine TVA inclus.
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default StationPricingCards;
